import inicialState from './macroscopia.state';
import * as actions from './macroscopia.action';

const macroscopiaReducer = (state = inicialState, action) => {
    switch (action.type) {
        case actions.SHOW_FADE_CARREGANDO:
            return {
                ...state,
                showCarregando: action.payload.showCarregando,
            }
        case actions.PREENCHER_FILTRO_MACROSCOPIA:
            return {
                ...state,
                filtros: action.payload.filtros
            }
        case actions.PREENCHER_FAVORITOS:
            return {
                ...state,
                favoritos: action.payload.favoritos
            }
        case actions.PREENCHER_LISTAGEM_MACROSCOPIA:
            return {
                ...state,
                listagem: action.payload.listagem
            }
        case actions.PREENCHER_DETALHES:
            return {
                ...state,
                detalhes: action.payload.detalhes
            }
        case actions.PREENCHER_FRASCOS:
            return {
                ...state,
                frascos: action.payload.frascos
            }
        case actions.PREENCHER_SELECT_MATERIAL:
            return {
                ...state,
                material: action.payload.material
            }
        case actions.PREENCHER_SELECT_TIPO:
            return {
                ...state,
                tipo: action.payload.tipo
            }
        case actions.PREENCHER_SELECT_MEDICO_MACRO:
            return {
                ...state,
                medicoMacroscopista: action.payload.medicoMacroscopista
            }
        case actions.PREENCHER_SELECT_MEDICO_TECNICO:
            return {
                ...state,
                medicoTecnico: action.payload.medicoTecnico
            }
        case actions.ADICIONAR_BLOCO:
            return {
                ...state,
                blocos: action.payload.blocos
            }
        case actions.ADICIONAR_BLOCOS_TEMPORARIOS:
            return {
                ...state,
                blocosNovos: action.payload.blocosNovos
            }
        case actions.ADICIONAR_BLOCOS_EXISTENTES:
            return {
                ...state,
                blocosExistentes: action.payload.blocosExistentes
            }
        case actions.PREENCHER_PROTOCOLO:
            return {
                ...state,
                protocolo: action.payload.protocolo
            }
        case actions.PREENCHER_LAMINA_PROTOCOLO:
            return {
                ...state,
                laminas: action.payload.laminas
            }
        case actions.PREENCHER_CENTRO_RESPONSABILIDADE:
            return {
                ...state,
                centroResponsabilidades: action.payload.centroresponsabilidade
            }
        case actions.PREENCHER_CESTAS:
            return {
                ...state,
                cestas: action.payload.cestas
            }
        case actions.DELEGAR_BLOCO_CESTA:
            return {
                ...state,
                blocoNaCesta: action.payload.blocoCesta
            }
        case actions.PREENCHER_NAO_CONFORMIDADES:
            return {
                ...state,
                naoConformidades: action.payload.naoConformidades
            }
        case actions.PREENCHER_HISTORICO_NAO_CONFORMIDADES:
            return {
                ...state,
                historicoNaoConformidades: action.payload.historicoNaoConformidades
            }
        case actions.PREENCHER_EXAMES_ABERTOS_MACRO:
            return {
                ...state,
                examesAbertos: action.payload.examesAbertos
            }
        case actions.ATUALIZAR_TEXTO_RTF:
            return {
                ...state,
                rtf: action.payload.rtf
            }
        case actions.ARMAZENAR_TEXTO_LAUDO_RTF:
            return {
                ...state,
                laudoExameRtf: action.payload.laudoExameRtf
            }
        case actions.COLLAPSED_CONTAINER_EXAMES:
            return {
                ...state,
                collapseContainerExames: action.payload.collapseContainerExames
            }
        case actions.LISTAGEM_EXAMES_LAUDO:
            return {
                ...state,
                listagemExames: action.payload.listagemExames
            }
        case actions.LISTAGEM_MEDICOS:
            return {
                ...state,
                medicos: action.payload.medicos
            }
        case actions.ARGUMENTOS_SALVAR_ETAPA_LAUDO:
            return {
                ...state,
                laudarEtapaRequest: action.payload.laudarEtapaRequest
            }
        case actions.ALTERAR_AUTOSAVE_TEXTO_LAUDO:
            return {
                ...state,
                autoSaveAtivo: action.payload.autoSaveAtivo
            }
        case actions.MACROSCOPIA_FINALIZADA:
            return {
                ...state,
                macroscopiaFinalizada: action.payload.macroscopiaFinalizada
            }
        case actions.IMPRIMIR_CONTROLE_CASSETE_FINALIZAR_MAPA:
            return {
                ...state,
                imprimirControleCassetesAoFinalizarMapa: action.payload.imprimirControleCassetesAoFinalizarMapa
            }
        case actions.VISIBILIDADE_MODAL_MAPAMACROSCOPICO:
            return {
                ...state,
                visibilidadeModalMapaMacroscopico: action.payload.visibilidadeModalMapaMacroscopico
            }
        default:
            return state;
    }
}

export default macroscopiaReducer;


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/macroscopia.reducer.js